export const getMovementStyles = (type) => {
  switch(type) {
    case 'add':
      return {
        border: 'border-l-green-500',
        bg: 'bg-green-50',
        text: 'text-green-700',
        icon: '➕',
        label: 'Alta'
      };
    case 'remove':
      return {
        border: 'border-l-red-500',
        bg: 'bg-red-50',
        text: 'text-red-700',
        icon: '➖',
        label: 'Baja'
      };
    case 'modify':
      return {
        border: 'border-l-yellow-500',
        bg: 'bg-yellow-50',
        text: 'text-yellow-700',
        icon: '📝',
        label: 'Modificación'
      };
    case 'review':
      return {
        border: 'border-l-blue-500',
        bg: 'bg-blue-50',
        text: 'text-blue-700',
        icon: '📋',
        label: 'Repaso'
      };
    default:
      return {
        border: 'border-l-gray-500',
        bg: 'bg-white',
        text: 'text-gray-700',
        icon: '❔',
        label: 'Otro'
      };
  }
}; 